import { createContext, useContext, useEffect, useState, type ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { FullPageWrapper, SpinnerLoader } from 'shared/ui'
import { RcsWizardStore } from 'pages/settings/pages/rcsV2/store/rcsWizardStore'

import styles from './styles.module.scss'

const RcsWizardContext = createContext<RcsWizardStore | null>(null)

export const useRcsWizardContext = () => {
  const context = useContext(RcsWizardContext)

  if (context === null) {
    throw new Error('You have forgotten to wrap with RcsWizardProvider')
  }

  return context
}

export const RcsWizardProvider = observer(({ children }: { children: ReactNode }) => {
  const [store] = useState(() => new RcsWizardStore())

  useEffect(() => store.dispose, [])

  return (
    <RcsWizardContext.Provider value={store}>
      {store.loading ? (
        <FullPageWrapper className={styles.loading}>
          <SpinnerLoader ariaLabel={'RcsWizardProvider'} />
        </FullPageWrapper>
      ) : (
        children
      )}
    </RcsWizardContext.Provider>
  )
})
